import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GroupOption, OptionState } from "./index.types";

const initialState: OptionState = {
  isGroupsLoading: false,
  groupsOptions: [],
};

const name = "options";

const excludedGroups = ["front desk representatives", "medical assistants"];

export const optionSlice = createSlice({
  name,
  initialState,
  reducers: {
    getGroups: (state, action: PayloadAction<any>) => {
      state.isGroupsLoading = true;
    },
    getGroupsSuccess: (state, action: PayloadAction<any>) => {
      state.isGroupsLoading = false;
      const { results = [] } = action.payload;
      state.groupsOptions = results?.reduce((acc: GroupOption[], { id, name }: any) => {
        /* This check is only for the MVP because following are not included:
                (Front Desk Representatives & Medical Assistants) */
        if (!excludedGroups.includes(name.toLowerCase())) {
          acc.push({ value: id, label: name });
        }
        return acc;
      }, []);
    },
    getGroupsFail: (state) => {
      state.isGroupsLoading = false;
      state.groupsOptions = [];
    },
  },
});

export const { getGroups } = optionSlice.actions;

export default optionSlice.reducer;

export const getGroupsOptions = () => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/groups/`,
  },
  type: "getGroups",
});
